import { render, staticRenderFns } from "./header-buttons.vue?vue&type=template&id=be5575f0&"
import script from "./header-buttons.vue?vue&type=script&lang=ts&"
export * from "./header-buttons.vue?vue&type=script&lang=ts&"
import style0 from "./header-buttons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports